import { useEffect, useState } from "react";

export const PRODUCT_MIN_CHARS = 3;
const DEBOUNCE_MS = 400;

const formatDate = (iso) => (iso ? new Date(`${iso.slice(0, 10)}T00:00:00`).toLocaleDateString("fr-FR") : "");

/** Valeur envoyée au serveur : vide sous 3 caractères, sinon le terme après une pause de frappe. */
export const useDebouncedProductFilter = (query) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    const term = query.trim();
    const next = term.length >= PRODUCT_MIN_CHARS ? term : "";
    const t = setTimeout(() => setValue(next), next ? DEBOUNCE_MS : 0);
    return () => clearTimeout(t);
  }, [query]);
  return value;
};

/** Nom du client + dernière facture correspondante : infobulle au survol (bureau), ligne visible (mobile). */
export const InvoicedProductMatch = ({ client, children }) => {
  const m = client.invoiced_match;
  if (!m) return children;
  const text = `Dernière facture : ${m.number} du ${formatDate(m.date)}`;
  return (
    <span className="relative inline-block group/match" data-testid={`invoiced-match-${client.id}`}>
      <span className="underline decoration-dotted decoration-slate-300 underline-offset-2">{children}</span>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-0 top-full z-40 mt-1 hidden whitespace-nowrap rounded-md border border-slate-200 bg-white px-2.5 py-1.5 text-[11px] font-normal text-slate-700 shadow-xl md:group-hover/match:block"
        data-testid={`invoiced-match-tooltip-${client.id}`}
      >
        {text}
      </span>
      <span className="md:hidden block text-[10px] font-normal text-indigo-600" data-testid={`invoiced-match-mobile-${client.id}`}>{text}</span>
    </span>
  );
};
